<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section v-if="!insideModal" class="q-py-xs">
            <div v-if="name === 'btPesquisar'" class="crud-title">
              <translate>SEARCH_RECORDS</translate>
            </div>
            <div v-else-if="name === 'btNovo'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
            <div
              v-else-if="forms[0].nmInterface.indexOf('.alterar') > 0"
              class="crud-title"
            >
              <translate>UPDATE_REGISTRATION</translate>
            </div>
            <div v-else-if="labelPage" class="crud-title">
              {{ labelPage }}
            </div>
          </q-card-section>
          <q-card-section class="q-px-md">
            <crud-form
              ref="dynamicForm"
              :form="elements[0]"
              :model="elements[0].dadosForm"
              @action-click="actionClick"
            >
              <div class="row">
                <crud-input class="col-7 q-px-sm" nmInput="name" />
                <crud-input class="col-5 q-px-sm" nmInput="code" />
                <crud-input class="col-5 q-px-sm" nmInput="integrationCode" />
                <crud-input class="col-7 q-px-sm" nmInput="parent" />

                <crud-compositions
                  class="col-12 q-px-sm"
                  :form="elements[0]"
                  :model="elements[0].dadosForm"
                  @action-click="onCompositionActionClick"
                >
                  <crud-composition
                    ref="modalForm"
                    slot="organizationalStructurePropertyValues"
                    slot-scope="dados"
                    v-bind="dados"
                  >
                    <template #table="dadosTable">
                      <jt-data-table
                        v-bind="dadosTable"
                        :columnEdit="formatPropertyValueColumn"
                        @action-button="dadosTable.actionButton"
                        @show-message="dadosTable.showMessage"
                      />
                    </template>
                    <template #modal-form="dadosModal">
                      <div class="formContainer">
                        <div class="full-width full-height">
                          <jt-dynamic-form
                            :key="`dynamic-form-${dadosModal.form.dadosForm.isValueCombo ? 'combo' : dadosModal.form.dadosForm.isValueText ? 'text' : 'default'}`"
                            ref="dynamicForm2"
                            :inputs="dadosModal.form.inputs"
                            :relacionamentos="dadosModal.form.relacionamentos"
                            :model="dadosModal.form.dadosForm"
                            :interface="dadosModal.form.nmInterface"
                            form-class="form dynamic"
                            @composition-button-click="actionButtonComposition"
                            @composition-modal-close="
                              compositionModalCloseHandler
                            "
                            @on-select-change="
                              (input, selectedValue) => {
                                onSelectChange(
                                  dadosModal,
                                  input,
                                  selectedValue
                                );
                              }
                            "
                          />

                          <div
                            class="row full-width justify-center q-gutter-md"
                            v-if="
                              dadosModal && !!dadosModal.form.buttons.length
                            "
                          >
                            <div
                              v-for="(button, index) in dadosModal.form.buttons"
                              :key="index"
                              class="buttons-bar"
                            >
                              <div class="full-width row">
                                <q-btn
                                  class="q-px-xl"
                                  :color="
                                    button.type.toUpperCase() == 'SUBMIT'
                                      ? 'info'
                                      : 'grey-7'
                                  "
                                  @click="
                                    () => {
                                      storeFormDataBeforeSubmit(dadosModal.form.dadosForm);
                                      populateUnifiedValue(dadosModal.form.dadosForm);
                                      dadosModal.formButtonClick({
                                        button,
                                        fields: dadosModal.form.dadosForm,
                                      });
                                    }
                                  "
                                  >{{ button.label }}</q-btn
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </crud-composition>
                </crud-compositions>
              </div>
            </crud-form>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-py-md"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        :class="`col-lg-2 col-md-3 button-${
          button.name ? button.name.toLowerCase() : button.name
        }`"
      >
        <q-btn
          :class="`full-width button-btn-${
            button.name ? button.name.toLowerCase() : button.name
          }`"
          color="info"
          @click="actionButton(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import { repository } from 'jtech'
import { organizationalStructurePropertyType } from 'src/shared/inf-tabela-descricao/OrganizationalStructurePropertyType.enum.js'
const { form, input, compositions, composition, page } = JtCrud

@Component({
  mixins: [page],
  name: 'OrganizationalStructurePage',
  components: {
    'crud-form': form,
    'crud-input': input,
    'crud-compositions': compositions,
    'crud-composition': composition,
    JtDataTable
  }
})
export default class OrganizationalStructurePage extends Vue {
  get elements () {
    this.form(this.forms, this.params)
    return this.forms
  }

  form (forms, params) {
    forms.forEach((form) => {
      form.inputs.forEach((input) => {
        if (input.type != 'DATATABLE') this.label(input, params)
      })
    })
  }

  label (elem, params) {
    try {
      if (elem.label && elem.label[0] === '$') {
        const key = elem.label.substring(2, elem.label.length - 1)
        elem.label = params[key] ?? elem.label
      }
    } catch (error) {}
  }

  async selectAjaxHandler (organizationalStructureProperty) {
    return await repository.resolveSelectAjax(
      'organizationalStructurePropertyValue.composicao',
      {
        nmAtributo: 'organizationalStructureProperty',
        organizationalStructureProperty: organizationalStructureProperty
      }
    )
  }

  get organizationalStructurePropertyType () {
    return organizationalStructurePropertyType()
  }

  _pendingPropertyValueFormData = null

  formatDecimalForDisplay (value) {
    if (value == null || value === '') return null
    const num = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'))
    if (isNaN(num)) return null
    const decimals = 2
    return num
      .toFixed(decimals)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  }

  storeFormDataBeforeSubmit (dadosForm) {
    if (!dadosForm) return
    const hasDecimal = dadosForm.valueFloat != null && dadosForm.valueFloat !== ''
    this._pendingPropertyValueFormData = hasDecimal
      ? {
        valueFloat: dadosForm.valueFloat,
        value: dadosForm.valueFloat,
        valueLabel: this.formatDecimalForDisplay(dadosForm.valueFloat)
      }
      : null
  }

  onCompositionActionClick (payload) {
    if (this._pendingPropertyValueFormData && payload.model && payload.button) {
      const isSaveButton = payload.button.name === 'btSalvarComposicao'
      if (isSaveButton && payload.model.length > 0) {
        const lastRow = payload.model[payload.model.length - 1]
        const pending = this._pendingPropertyValueFormData
        this.$set(lastRow, 'valueFloat', pending.valueFloat)
        this.$set(lastRow, 'value', pending.value)
        if (pending.valueLabel != null) {
          this.$set(lastRow, 'valueLabel', pending.valueLabel)
        }
      }
      this._pendingPropertyValueFormData = null
    }
    this.actionClick(payload)
  }

  formatPropertyValueColumn ({ col, props }) {
    const isValueCol = col.name === 'value' || col.field === 'value' ||
      col.name === 'valueLabel' || col.field === 'valueLabel'
    if (!isValueCol) return null
    const row = props.row
    const hasValueNumber = row.isValueMumber === true || (row.valueNumber != null && row.valueNumber !== '')
    if (hasValueNumber) {
      return row.valueLabel != null && row.valueLabel !== '' ? row.valueLabel : (row.valueNumber != null && row.valueNumber !== '' ? row.valueNumber : null)
    }
    const hasValueFloat = row.valueFloat != null && row.valueFloat !== ''
    const decimalValue = hasValueFloat ? Number(String(row.valueFloat).replace(',', '.')) : (typeof row.value === 'number' ? row.value : parseFloat(String(row.value || '').replace(',', '.')))
    if (isNaN(decimalValue)) return null
    if (!hasValueFloat && Number.isInteger(decimalValue)) return null
    const formatted = this.formatDecimalForDisplay(decimalValue)
    return formatted != null ? formatted : null
  }

  populateUnifiedValue (dadosForm) {
    if (!dadosForm) return
    const valueKeys = ['valueFloat', 'valueNumber', 'valueText', 'valueDate', 'valueCombo', 'value']
    const value = valueKeys
      .map((key) => dadosForm[key])
      .find((v) => v != null && v !== '')
    if (value != null && value !== '') {
      this.$set(dadosForm, 'value', value)
    }
  }

  async onSelectChange (dadosModal, input) {
    const selectedValue = input?.selectedValue
    
    const isStringValue = typeof selectedValue === 'string' && !/^\d+$/.test(selectedValue)
    
    if (isStringValue) {
      console.debug('[OrganizationalStructurePage] Evento ignorado - é valor do combo (string):', {
        selectedValue
      })
      return
    }
    
    console.debug('[OrganizationalStructurePage] Processando seleção do campo de propriedade:', {
      selectedValue,
      isNumber: typeof selectedValue === 'number' || /^\d+$/.test(String(selectedValue))
    })
    
    this.$nextTick(async () => {
      const { reRender } = await this.selectAjaxHandler(input.selectedValue)
      const type = this.organizationalStructurePropertyType
      
      console.debug('[OrganizationalStructurePage] Inputs disponíveis:', dadosModal.form.inputs.map((inp, idx) => ({
        index: idx,
        name: inp.name,
        model: inp.model,
        dataName: inp.dataName,
        nmInput: inp.nmInput,
        type: inp.type,
        label: inp.label,
        hidden: inp.hidden,
        readonly: inp.readonly
      })))
      
      const typeSpecificFields = ['valueText', 'valueNumber', 'valueFloat', 'valueDate', 'valueCombo']
      
      dadosModal.form.inputs.forEach(inp => {
        if (typeSpecificFields.includes(inp.name) || typeSpecificFields.includes(inp.model)) {
          this.$set(inp, 'renderIf', '1 == 0')
          console.debug('[OrganizationalStructurePage] Ocultando campo específico de tipo:', {
            name: inp.name,
            model: inp.model,
            type: inp.type
          })
        }
      })
      
      if (!dadosModal.form.relacionamentos) {
        dadosModal.form.relacionamentos = {}
      }
      
      console.debug('[OrganizationalStructurePage] Valores do enum:', {
        VALUE_TEXT: type.VALUE_TEXT.key,
        VALUE_NUMBER: type.VALUE_NUMBER.key,
        VALUE_FLOAT: type.VALUE_FLOAT.key,
        VALUE_DATE: type.VALUE_DATE.key,
        VALUE_COMBO: type.VALUE_COMBO.key
      })
      
      const typeEnumKeys = [type.VALUE_TEXT.key, type.VALUE_NUMBER.key, type.VALUE_FLOAT.key, type.VALUE_DATE.key, type.VALUE_COMBO.key]
      const selectedValueIsType = typeEnumKeys.some(k => k == selectedValue || k === selectedValue)
      const relsToProcess = selectedValueIsType
        ? reRender.organizationalStructurePropertyType.filter(rel => rel.value == selectedValue || rel.value === selectedValue)
        : reRender.organizationalStructurePropertyType

      relsToProcess.forEach((rel) => {
        const labelLower = rel.label ? rel.label.toLowerCase() : ''
        dadosModal.form.dadosForm.isValueText = rel.value == type.VALUE_TEXT.key || labelLower.includes('text') || labelLower.includes('texto')
        dadosModal.form.dadosForm.isValueMumber = rel.value == type.VALUE_NUMBER.key || labelLower.includes('number') || labelLower.includes('inteiro') || labelLower.includes('número')
        dadosModal.form.dadosForm.isValueFloat = rel.value == type.VALUE_FLOAT.key || labelLower.includes('float') || labelLower.includes('decimal')
        dadosModal.form.dadosForm.isValueDate = rel.value == type.VALUE_DATE.key || labelLower.includes('date') || labelLower.includes('data')
        dadosModal.form.dadosForm.isValueCombo = rel.value == type.VALUE_COMBO.key || labelLower.includes('combo')
        
        let fieldToShow = null
        if (rel.value == type.VALUE_TEXT.key || labelLower.includes('text') || labelLower.includes('texto')) {
          fieldToShow = 'valueText'
        } else if (rel.value == type.VALUE_FLOAT.key || labelLower.includes('float') || labelLower.includes('decimal')) {
          fieldToShow = 'valueFloat'
        } else if (rel.value == type.VALUE_NUMBER.key || labelLower.includes('number') || labelLower.includes('inteiro') || labelLower.includes('número')) {
          fieldToShow = 'valueNumber'
        } else if (rel.value == type.VALUE_DATE.key || labelLower.includes('date') || labelLower.includes('data')) {
          fieldToShow = 'valueDate'
        } else if (rel.value == type.VALUE_COMBO.key || labelLower.includes('combo')) {
          fieldToShow = 'valueCombo'
        }
        
        if (fieldToShow) {
          let specificField = dadosModal.form.inputs.find(inp => inp.name === fieldToShow || inp.model === fieldToShow)
          if (!specificField && fieldToShow === 'valueText') {
            specificField = dadosModal.form.inputs.find(inp => inp.name === 'value' || inp.model === 'value')
          }
          if (specificField) {
            delete specificField.renderIf
          }
        }

        const isCombo = rel.value == type.VALUE_COMBO.key || 
                       rel.value === type.VALUE_COMBO.key ||
                       (rel.label && rel.label.toLowerCase().includes('combo'))
        
        if (isCombo) {
          const comboData = reRender.organizationalStructurePropertyCombo || reRender.valueCombo
          
          console.debug('[OrganizationalStructurePage] Dados do combo:', comboData)
          
          if (comboData && Array.isArray(comboData)) {
            this.$set(dadosModal.form.relacionamentos, 'valueCombo', comboData)
            this.$set(dadosModal.form.relacionamentos, 'organizationalStructurePropertyCombo', comboData)
            
            console.debug('[OrganizationalStructurePage] Combo carregado para valueCombo')
          }
        }
        
        console.debug('[OrganizationalStructurePage] Tipo selecionado:', {
          value: rel.value,
          label: rel.label,
          fieldToShow: fieldToShow,
          isValueText: dadosModal.form.dadosForm.isValueText,
          isValueCombo: dadosModal.form.dadosForm.isValueCombo,
          isValueNumber: dadosModal.form.dadosForm.isValueMumber,
          isValueFloat: dadosModal.form.dadosForm.isValueFloat,
          isValueDate: dadosModal.form.dadosForm.isValueDate
        })
      })
      
      console.debug('[OrganizationalStructurePage] Inputs finais antes da renderização:', dadosModal.form.inputs.map(inp => ({
        name: inp.name,
        type: inp.type,
        hidden: inp.hidden,
        readonly: inp.readonly,
        visible: inp.visible
      })))
      
      this.$forceUpdate()
      
      this.$nextTick(() => {
        if (this.$refs.dynamicForm2) {
          this.$refs.dynamicForm2.$forceUpdate()
        }
        if (this.$refs.modalForm && this.$refs.modalForm.$refs && this.$refs.modalForm.$refs.dynamicForm2) {
          this.$refs.modalForm.$refs.dynamicForm2.$forceUpdate()
        }
      })
    })
  }
}
</script>
<style lang="stylus" scoped></style>
